module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/send-fill-f1cba2d614b02a28fe343181a3312f72.svg";